module.exports = __webpack_public_path__ + "static/media/Manjaro_wallpaper_no_logo.74af6862.png";